import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {Typography} from "@material-ui/core";
import DateRangeIcon from "@material-ui/icons/DateRange";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import InfoField from "../InfoField";
import {format, parseISO} from "date-fns";
import ru from "date-fns/locale/ru";

const useStyles = makeStyles({
  dateRange: {
    marginTop: 16,
    "& span": {
      color: "#00334E",
      marginBottom: 10,
      marginLeft: 4,
      marginRight: 4,
      display: "inline-block",
      "vertical-align": "middle"
    },
    "& .MuiSvgIcon-root": {
      fill: "#00334E",
      display: "inline-block"
    }
  }
});

const formatDate = date =>
  date ? format(parseISO(date), "dd.MM.yyyy", { locale: ru }) : null;

export default function DateRangeBlock({ infoName, dateFrom, dateTo }) {
  const classes = useStyles();

  return (
    <InfoField name={infoName} display={"block"} value={
      <Typography className={classes.dateRange}>
        <DateRangeIcon fontSize="small" />
        <span>{dateFrom ? formatDate(dateFrom) : 'не указано'}</span>
        <ArrowForwardIcon fontSize="small" />
        <span>{dateTo ? formatDate(dateTo) : 'не указано'}</span>
      </Typography>}
    />
  );
};
